import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';

import './AboutUs.css';
import { client, urlFor } from '../../../src/sanityClient';

function AboutUs() {
    const [aboutData, setAboutData] = useState(null);

    useEffect(() => {
        client.fetch(`*[_type == "aboutMe"]`)
            .then(data => {
                console.log("Fetched data:", data);
                if (data && data.length > 0) {
                    setAboutData(data[0]);
                } else {
                    console.log("No data found for type 'aboutMe'");
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }, []);

    if (!aboutData) return <div>Loading...  no data available</div>;

    return (
        <Container fluid className="AboutUspage">
            <Row>
                <Col xs={12} md={12} lg={9} className="aboutbody">
                    <div >
                        <h2 className="aboutHeadingxxx">{aboutData.heading}</h2>
                        <p className="aboutHeadingParagraph">{aboutData.description}</p>
                    </div>
                </Col>
          </Row>

           
           <Row  >
           {aboutData.skills.map((skill, index) => (
                    <Col xs={12} md={6} lg={6}  key={index}>
                        <div className="myRole" >
                            <h5>
                            <img
                                style={{marginRight:0.4+'rem'}}
                                className="img-fluid LoaderImage"
                                src={urlFor(skill.icon).url()}
                                alt={skill.title}
                                />
                                {skill.title}
                            </h5>
                            <p style={{wordSpacing:0.1+'rem',lineHeight:199+"%"}}>
                                {skill.description}
                            </p>
                        </div>
                    </Col>
                ))}
           </Row>
              
           
        </Container>
    );
}

export default AboutUs;